import React, { Component } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const CZECHIA_CENTER = { lat: 49.8175, lng: 15.4730 };

class BusSignsPositionPicker extends Component {

    getPosition() {
        const lat = Number(this.props.lat);
        const lng = Number(this.props.lon);
        if (this.props.lat === '' || this.props.lat === undefined || this.props.lat === null
            || this.props.lon === '' || this.props.lon === undefined || this.props.lon === null
            || Number.isNaN(lat) || Number.isNaN(lng)) {
            return null;
        }
        return { lat, lng };
    }

    updatePosition = (latLng) => {
        this.props.onPositionChange(latLng.lat(), latLng.lng());
    };

    handleMapClick = (e) => {
        this.updatePosition(e.latLng);
    };

    handleMarkerDragEnd = (e) => {
        this.updatePosition(e.latLng);
    };

    render() {
        const position = this.getPosition();
        return (
            <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
                <GoogleMap
                    mapContainerStyle={{ width: '100%', height: 300 }}
                    center={position || CZECHIA_CENTER}
                    zoom={position ? 16 : 7}
                    onClick={this.handleMapClick}
                >
                    {position &&
                        <Marker
                            position={position}
                            draggable
                            onDragEnd={this.handleMarkerDragEnd}
                        />
                    }
                </GoogleMap>
            </LoadScript>
        );
    }
}

export default BusSignsPositionPicker;
